export default {"src":"/_next/static/media/create-folder.d6f919da.svg","height":11,"width":12,"blurWidth":0,"blurHeight":0};